import { DateRange } from "react-day-picker";

export interface ProcessedDateRange {
  start: Date | undefined;
  end: Date | undefined;
}

/**
 * Processes a DateRange to ensure the end date includes the full day (23:59:59.999)
 * and returns start/end dates ready for API queries
 */
export function processDateRange(
  range: DateRange | undefined,
): ProcessedDateRange {
  if (!range) {
    return { start: undefined, end: undefined };
  }

  let start: Date | undefined = undefined;
  let end: Date | undefined = undefined;

  if (range.from) {
    start = new Date(range.from);
    start.setHours(0, 0, 0, 0); // Start of day
  }

  if (range.to) {
    end = new Date(range.to);
    end.setHours(23, 59, 59, 999); // End of day
  }

  return { start, end };
}

/**
 * Converts a processed date range to ISO strings for API queries
 */
export function dateRangeToISOStrings(processed: ProcessedDateRange): {
  startISO: string | undefined;
  endISO: string | undefined;
} {
  return {
    startISO: processed.start?.toISOString(),
    endISO: processed.end?.toISOString(),
  };
}
